/* ===================================================================
   AdminView context object + hook (Option A operator read-only view).
   Kept in a .ts module (no component export) so the provider component can
   live in its own .tsx file -- satisfies react-refresh/only-export-components.
   See AdminViewContext.tsx for the provider + the full design note.
   =================================================================== */
import { createContext, useContext } from 'react';

export interface AdminViewState {
  /** The tenant client_id the operator is viewing. */
  clientId: string;
  /** Always true inside the provider. Components hide write affordances on it. */
  readOnly: true;
}

export const AdminViewContext = createContext<AdminViewState | null>(null);

/* Returns the admin-view state when the tree is being rendered as an operator
   read-only view, or null for the normal signed-in client. */
export function useAdminView(): AdminViewState | null {
  return useContext(AdminViewContext);
}
